const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const saveEmail = async (email: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/emails`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    throw new Error("Failed to save email");
  }
};
